import { Controller } from "@hotwired/stimulus";
import i18n from "../lib/i18n";

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:frame-missing", this.handleMissing);
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-missing", this.handleMissing);
  }

  handleMissing = (event) => {
    event.preventDefault();

    this.element.innerHTML = `
      <div>
        <p>${i18n.t("js.stimulus_controllers.action_types_fallback.loading_error")}</p>
        <p>${i18n.t("js.stimulus_controllers.action_types_fallback.try_again")}</p>
      </div>
    `;
  };
}
